import gql from 'graphql-tag';

import { gql as gqlFn } from '@/graphql/__generated__';

export const membershipsOfUserQuery = gqlFn(/* GraphQL */ `
  query membershipsOfUser {
    memberships {
      edges {
        node {
          ...MembershipWithTenant
        }
      }
    }
  }
`);

export const membershipsAllQuery = gqlFn(/* GraphQL */ `
  query memberships($tenant: ID!, $orderBy: [String!]) {
    memberships(tenant: $tenant, orderBy: $orderBy) {
      edges {
        node {
          ...MembershipWithUser
        }
      }
    }
  }
`);

export const membershipDetailsQuery = gqlFn(/* GraphQL */ `
  query membership($id: ID!) {
    membership(id: $id) {
      ...MembershipWithUser
    }
  }
`);

export const createMembershipMutation = gqlFn(/* GraphQL */ `
  mutation CreateMembership($tenant: ID!, $userEmail: String!, $isAdmin: Boolean!) {
    createMembership: createMembershipV2(
      input: { tenant: $tenant, userEmail: $userEmail, isAdmin: $isAdmin }
    ) {
      membership {
        ...MembershipWithUser
      }
    }
  }
`);

export const updateMembershipMutation = gqlFn(/* GraphQL */ `
  mutation UpdateMembership($id: ID!, $isAdmin: Boolean!) {
    updateMembership: updateMembershipV2(input: { id: $id, isAdmin: $isAdmin }) {
      membership {
        ...MembershipWithUser
      }
    }
  }
`);

export const deleteMembershipMutation = gqlFn(/* GraphQL */ `
  mutation DeleteMembership($id: ID!) {
    deleteMembership(input: { id: $id }) {
      success
    }
  }
`);

const membershipFragment = gql`
  fragment Membership on MembershipNode {
    id
    isAdmin
  }
`;

const membershipWithTenantFragment = gql`
  fragment MembershipWithTenant on MembershipNode {
    ...Membership
    tenant {
      id
      name
      logoUrl
    }
  }
`;

const membershipWithUserFragment = gql`
  fragment MembershipWithUser on MembershipNode {
    ...Membership
    user {
      id
      email
      firstName
      lastName
      mobileNumber
      isActive
      lastActiveAt
    }
  }
`;
